import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "./Nav";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const { refresh } = useAuth();
  const nav = useNavigate();
  const tries = useRef(0);

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch { /* retry */ }
      tries.current += 1;
      if (tries.current >= 20) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, refresh]);

  return (
    <div id="memberDash" data-testid="payment-success">
      <div className="dash-nav"><Logo /></div>
      <div className="dash-body">
        {state === "checking" && (<><Loader2 size={40} className="spin pay-ico" /><h2>Confirming<br /><em>your payment…</em></h2><p>This only takes a few seconds.</p></>)}
        {state === "paid" && (<><CheckCircle2 size={44} className="pay-ico" /><div className="dash-eye">Payment Received</div><h2>You're in.<br /><em>Your edge is ready.</em></h2><p>Your plan is active on your account.</p><button className="dash-btn" onClick={() => nav("/dashboard")} data-testid="go-dashboard">Go To Dashboard →</button></>)}
        {state === "timeout" && (<><Loader2 size={40} className="pay-ico" /><h2>Still processing.<br /><em>Hang tight.</em></h2><p>Your payment is taking longer than usual. Refresh this page in a minute.</p><button className="dash-btn" onClick={() => window.location.reload()}>Check Again</button></>)}
        {state === "error" && (<><XCircle size={44} className="pay-ico dn" /><h2>Payment<br /><em>not completed.</em></h2><p>No charge was confirmed. You can try again anytime.</p><button className="dash-btn" onClick={() => nav("/#pricing")}>Back To Pricing</button></>)}
      </div>
    </div>
  );
};

export const PaymentCancel = () => {
  const nav = useNavigate();
  return (
    <div id="memberDash" data-testid="payment-cancel">
      <div className="dash-nav"><Logo /></div>
      <div className="dash-body">
        <XCircle size={44} className="pay-ico dn" />
        <div className="dash-eye">Checkout Cancelled</div>
        <h2>No worries.<br /><em>Nothing was charged.</em></h2>
        <p>Pick a plan whenever you're ready.</p>
        <button className="dash-btn" onClick={() => nav("/dashboard")} data-testid="cancel-back">Back To Plans →</button>
      </div>
    </div>
  );
};
